var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"dense":_vm.dense,"clearable":"","value":_vm.value,"item-value":"id","item-text":"name","label":_vm.label,"items":_vm.structures,"rules":_vm.rules,"disabled":_vm.disabled,"return-object":"","outlined":_vm.outlined},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }